import { useState } from "react";
import { Container, Modal, Button, Table } from "react-bootstrap";

import { Upload } from "./FormFields/Upload";
import { ControlButtons } from "./ControlButtons";

export const PlotPlan = ({
  currPlotPlan = {},
  onNext = () => {},
  onPrevious = () => {},
  onSubmit = () => {},
  finalStep = false,
  disablePrev = false,
  disableNext = false,
  enableLoading = false,
}) => {
  const [currFile, setCurrFile] = useState(currPlotPlan.file);
  const [currAnswer, setCurrAnswer] = useState(currPlotPlan.answer);
  const [lgShow, setLgShow] = useState(false);

  return (
    <>
      <Container className="component mt-5">
        <h2 className="mb-4">Do you have a plot plan?</h2>
        <p>
          If you don't upload a plot plan in your application, you must come
          bring one in person.
        </p>
        <Button onClick={() => setLgShow(true)}>Guidelines</Button>
        <Upload
          className="mt-4"
          file={currFile}
          setFile={setCurrFile}
          answer={currAnswer}
          setAnswer={setCurrAnswer}
        />
      </Container>
      <Container>
        <ControlButtons
          onSubmit={() => onSubmit({ file: currFile, answer: currAnswer })}
          onNext={() => onNext({ file: currFile, answer: currAnswer })}
          onPrev={onPrevious}
          finalStep={finalStep}
          disableNext={currAnswer === null || (currAnswer && !currFile)}
          disablePrev={disablePrev}
          enableLoading={enableLoading}
        />
      </Container>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            <h2>Plot Plan Guidelines</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            When guard posts are required, they shall be installed meeting the
            following requirements: (R710-8.6.5)
          </p>
          <ol>
            <li>
              Constructed of steel not less than four inches in diameter and
              filled with concrete.
            </li>
            <li>Set with spacing not more than four (4) feet apart.</li>
            <li>
              Buried three (3) feet in the ground in concrete not less than 15
              inches in diameter.
            </li>
            <li>
              Set with tops of the posts not less than three (3) feet above the
              ground.
            </li>
          </ol>
          <br></br>
          <Table>
      <thead>
        <tr>
          <th colspan="4">Minimum separation between containers and buildings, public ways or lot lines of adjoining property that can be built upon.</th>
          
          
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Container capacity (water gallons)</td>
          <td>Mounded or underground container(s)(feet)</td>
          <td>Aboveground container(s)(feet)</td>
          <td>Minimum separation between containers</td>
        </tr>
        <tr>
          <td>Less than 125 gallons</td>
          <td>10'</td>
          <td>5'</td>
          <td>None</td>
        </tr>
        <tr>
          <td>125 to 250</td>
          <td>10'</td>
          <td>10'</td>
          <td>None</td>
        </tr>
        <tr>
          <td>251 to 500</td>
          <td>10'</td>
          <td>10'</td>
          <td>3'</td>
        </tr>
        <tr>
          <td>501 to 2,000</td>
          <td>10'</td>
          <td>25'</td>
          <td>3'</td>
        </tr>
      </tbody>
    </Table>
        </Modal.Body>
      </Modal>
    </>
  );
};
